// What a connector on the builder canvas shows about the filter of the service it runs into.
import type { Service } from "@/types";

export interface EdgeFilter {
  /** The child service has a filter. */
  hasFilter: boolean;
  /** This connector comes from the child's first parent. That one keeps the icon at rest, so a child with
   *  several parents has one icon. */
  isFirstParent: boolean;
}

// The kinds that collapse every transaction of the service before them into one (the engine's
// ServiceDefinition.IsFanIn). The engine never applies a filter to one of these, so a connector into one
// shows no filter icon.
const FAN_IN_TYPES = ["rejoin", "wait", "aggregate", "return"];

/** Undefined when the connector shows nothing: the child is a fan-in, or is not a saved service yet. */
export function edgeFilter(child: Service | undefined, parentId: string): EdgeFilter | undefined {
  if (!child) return undefined;

  const isFanIn = FAN_IN_TYPES.includes(child.serviceModelType.$type ?? "");
  if (isFanIn) return undefined;

  return {
    hasFilter: child.serviceFilterExpression.trim() !== "",
    isFirstParent: child.parentServiceIds[0] === parentId,
  };
}
